import { Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { PermissionFeature, PermissionModule, PermissionRole } from 'components/Permission/interface';
import colorTheme from 'constants/color';
import settingServiceActions from 'features/settingService/services/actions';
import settingServiceSelectors from 'features/settingService/services/selectors';
import { IPermissionConfigFeature, IPermissionConfigRes } from 'features/settingService/services/types/permission';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';

interface PermissionRowProps {
  record: IPermissionConfigRes,
  role: PermissionRole,
}

const PermissionRow = ({record, role}: PermissionRowProps) => {

  const dispatch = useAppDispatch();
  const dataChanged = settingServiceSelectors.getPermissionConfigChanged();
  const dataFiltered = settingServiceSelectors.getPermissionConfigFiltered();

  const getDataChange = (
      data: IPermissionConfigRes[] | null,
      module: PermissionModule,
      feature: PermissionFeature,
      role: PermissionRole,
      checked: boolean
    ) : IPermissionConfigRes[] => {
      return (data ?? []).map((permission) => {
        if(permission.moduleCode === module) {
          return {
            ...permission,
             features: permission.features.map(feat => {

              if(feat.featureCode === feature) {
                return {
                  ...feat,
                  roles: {
                    ...feat.roles,
                    [role]: checked
                  }
                } as IPermissionConfigFeature;
              }
              return feat;
            })
          };
        }
        return permission;
      });
    };
    
    const handleCheckboxChange = (
      module: PermissionModule,
      feature: PermissionFeature,
      role: PermissionRole,
      checked: boolean
    ) => {
      dispatch(settingServiceActions.updatePermissionConfigChanged(getDataChange(dataChanged, module, feature, role, checked)));
      dispatch(settingServiceActions.updatePermissionConfigFiltered(getDataChange(dataFiltered, module, feature, role, checked)));
    };

  return (
    <PermissionWrapper>
      {record.features.map(feature => (
        <CheckboxWrapper key={feature.featureCode}>
          <StyledCheckbox
            checked={feature?.roles?.[role]}
            onChange={(event: CheckboxChangeEvent) =>
              handleCheckboxChange(
                record.moduleCode,
                feature.featureCode,
                role,
                event.target.checked
              )
            }
          />
        </CheckboxWrapper>
      ))}
    </PermissionWrapper>
  );
};

export default PermissionRow;

const PermissionWrapper = styled.div`
`;

const StyledCheckbox = styled(Checkbox)`
  width: 100%;
  display: flex;
  align-items: center;
`;

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${colorTheme['v2_border_2']};
  height: 40px;
  padding: 0px;
  padding-left: 16px;
  &:last-child {
    border-bottom: none;
  }
`;